import axios from 'axios';
const CONTROLLER_PATH = 'SapdMetro';
class SapdMetroService {
    getlist() {
        return axios.get(CONTROLLER_PATH + '/getlist').then((response) => response.data);
    }
}

export default new SapdMetroService();
